import ElectronAppFeature from "./ElectronAppFeature";
import electron from "./electronMirror";

function isFeatureSupported(feature: ElectronAppFeature): boolean {
    return !!electron && feature in electron.features && !!electron.features[feature];
}

export const electronAppSupports = {
    popout: isFeatureSupported(ElectronAppFeature.Popout),
    webviews: isFeatureSupported(ElectronAppFeature.Webviews),
    SPA: isFeatureSupported(ElectronAppFeature.SPA),
    xdPlugin: isFeatureSupported(ElectronAppFeature.XDPlugin),
    newFigmaSSOFlow: isFeatureSupported(ElectronAppFeature.NewFigmaSSOFlow),
    newGoogleSSOFlow: isFeatureSupported(ElectronAppFeature.NewGoogleSSOFlow),
    newSlackIntegrationFlow: isFeatureSupported(ElectronAppFeature.NewSlackIntegrationFlow),
    newSSOFlow: isFeatureSupported(ElectronAppFeature.NewSSOFlow),
    nativeContextMenu: isFeatureSupported(ElectronAppFeature.NativeContextMenu),
    mfaLogin: isFeatureSupported(ElectronAppFeature.MFALogin),
    appMenu: isFeatureSupported(ElectronAppFeature.AppMenu),
    multiWindow: isFeatureSupported(ElectronAppFeature.MultiWindow),
    designRefresh2024: isFeatureSupported(ElectronAppFeature.DesignRefresh2024),
    importPNGs: isFeatureSupported(ElectronAppFeature.ImportPNGs),
    dragRegions: isFeatureSupported(ElectronAppFeature.DragRegions),
    updateUseDesktopAppForLinks: isFeatureSupported(ElectronAppFeature.UpdateUseDesktopAppForLinks),
    enableAIOrganizationAnimation: isFeatureSupported(ElectronAppFeature.EnableAIOrganizationAnimation)
};
